import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { BasicGeneratingScreen } from 'page/BasicInferenceScreen/BasicGeneratingScreen'
import { ItemRecommendationsModal } from 'page/BasicInferenceScreen/ItemRecommendationsModal/ItemRecommendationsModal'
import { itemRecommendations } from 'page/BasicInferenceScreen/ItemRecommendationsModal/ItemRecommendationsModalStore'
import { ItemsPane } from 'page/BasicInferenceScreen/ItemsPane'
import { Tele2QrModal } from 'page/BasicInferenceScreen/Tele2QrModal/Tele2QrModal'
import { tele2QrModal } from 'page/BasicInferenceScreen/Tele2QrModal/Tele2QrModalStore'
import { ImageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModal'
import { imageQrModal, ImageQrModalStore } from 'page/InferenceScreen/ImageQrModal/ImageQrModalStore'
import { Page } from 'page/Page/Page'
import { useEffect } from 'react'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { stat } from 'store/stat'
import { store } from 'store/store'
import css from './BasicInferenceScreen.module.scss'

export const BasicInferenceScreen = observer(() => {
  const { tablet } = store.frame
  const { busy } = store.inferences
  const item = store.carousel?.carousel.item
  const complete = item?.complete

  const onProfile = useLatestCallback(() => {
    store.screen = 'profile'
  })

  const onCatalog = useLatestCallback(() => {
    store.state = 'none'
  })

  const onRecommendations = useLatestCallback(() => {
    if (item) stat.recommendations(item.item_id, item.collection_id, item.inference_id)
    itemRecommendations.show()
  })

  const onShare = useLatestCallback(() => {
    if (item) imageQrModal.open(new ImageQrModalStore(item))
  })
  
  useEffect(() => {
    if (complete) void controller.viewInference(item)
  }, [complete, item])

  useEffect(() => {
    void itemRecommendations.load(item?.item_id)
  }, [item?.item_id])

  if (busy || !item || !item.complete) return <BasicGeneratingScreen />

  const buttons = (
    <Space gap={24} wide columns>
      <Button large action={onProfile}>
        {i18n('EditProfile')}
      </Button>
      <Button large action={onCatalog}>
        {i18n('GoToCatalog')}
      </Button>
    </Space>
  )

  return (
    <Page full center>
      <Vertical pad={[20, 40]} gap={24} wide tall center>
        <Vertical>
          <Typo size={16} tertiary upper center>
            {i18n('Generated')}
          </Typo>
          <Typo size={tablet ? 24 : 32} medium upper center>
            {i18n('YourOutfitIsReady')}
          </Typo>
        </Vertical>

        {opt.sochi && buttons}

        <Space wide spring center oh>
          <Space className={css.card} center>
            <Img className={css.image} src={item.source} />
            <Space pin={opt.sochi ? [12, 12, 12, null] : [null, 12, 12, null]}>
              <Button size={80} compact action={onShare}>
                <Icon size={32} name="ios_share" />
              </Button>
            </Space>
          </Space>
        </Space>

        <ItemsPane />

        {!!itemRecommendations.visible.length && <Button large wide action={onRecommendations}>
          {i18n('BoughtWithThisItem')}
        </Button>}

        {!opt.sochi && buttons}
      </Vertical>

      {itemRecommendations.open && <ItemRecommendationsModal />}
      {imageQrModal.present && <ImageQrModal />}
      {tele2QrModal.present && <Tele2QrModal />}
    </Page>
  )
})
